// Small demo text the editor opens with. Kept intentionally tiny — the rest of the page stays clear
// so the demo always presents clean (see advanced-editor.tsx: it always loads this, never a saved session).
export const defaultEditorContent = {
  type: "doc",
  content: [
    {
      type: "heading",
      attrs: { level: 2 },
      content: [{ type: "text", text: "Start writing…" }],
    },
    {
      type: "paragraph",
      content: [
        { type: "text", text: "Type " },
        { type: "text", marks: [{ type: "bold" }], text: "++" },
        { type: "text", text: " to continue a thought with AI, press " },
        { type: "text", marks: [{ type: "bold" }], text: "/" },
        { type: "text", text: " for commands, or select any text and click " },
        { type: "text", marks: [{ type: "bold" }], text: "Ask AI" },
        { type: "text", text: " to rewrite it." },
      ],
    },
  ],
};
